<template>
	<span>授权失败</span>
</template>
<script>
export default {
	name: 'contents',
	props: {
		url: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			token:"",
		}
	},
	methods: {},
	created() {},
	mounted() {},
}
</script>

<style scoped></style>
